import { ServiceList } from "@/components/ServiceList";
import { groomingPdfUrl } from "@/lib/api";
import { Scissors } from "lucide-react";

export default function Grooming() {
  return (
    <ServiceList
      kind="grooming"
      title="Grooming"
      icon={Scissors}
      pdfUrlFn={groomingPdfUrl}
      newPath="/grooming/new"
      editPath={(id) => `/grooming/${id}/edit`}
      renderMeta={(r, p) => `${p.case_number || ""} · ${r.branch || ""} · ${new Date(r.created_at).toLocaleDateString()}`}
    />
  );
}
